module.exports = __webpack_public_path__ + "img/smiling-face.5578a4c5.png";